import { useScoreBreakdownStore } from '@/store/scoreBreakdownStore';
import { useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { renderNumericColumn } from '@/utils/renderTableValue';
import { trackEvent } from '@/utils/analytics';

export function ScoreInfoButton({ data, value }: { data: any; value: any }) {
  const setScoreBreakdownRow = useScoreBreakdownStore(s => s.setScoreBreakdownRow);
  const btnRef = useRef<HTMLButtonElement>(null);
  const [pos, setPos] = useState<{ x: number; y: number } | null>(null);
  const display = renderNumericColumn(value);

  const handleMouseEnter = () => {
    if (btnRef.current) {
      const r = btnRef.current.getBoundingClientRect();
      setPos({ x: r.left + r.width / 2, y: r.top });
    }
  };

  return (
    <>
      <button
        ref={btnRef}
        type="button"
        className="tab-links pr-5"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={() => setPos(null)}
        onClick={e => {
          e.stopPropagation();
          trackEvent({
            name: 'score_breakdown_open',
            buttonId: 'table_open_score_breakdown',
            label: 'Open score breakdown',
            page: 'search_results',
            section: 'results_table',
            feature: 'score_breakdown',
            eventCategory: 'table',
          });
          setScoreBreakdownRow(data ?? { score: value });
        }}
        aria-label="View score breakdown"
      >
        {display}
      </button>

      {pos &&
        createPortal(
          <div
            className="pointer-events-none"
            style={{
              position: 'fixed',
              left: pos.x,
              top: pos.y - 8,
              transform: 'translateX(-50%) translateY(-100%)',
              zIndex: 99999,
            }}
          >
            <div className="bg-gray-900 text-white text-xs px-2.5 py-1.5 rounded-md shadow-lg whitespace-nowrap">
              Click to see how this score is calculated
            </div>
            <div
              className="mx-auto w-0 h-0"
              style={{
                borderLeft: '5px solid transparent',
                borderRight: '5px solid transparent',
                borderTop: '5px solid #111827',
                width: 'fit-content',
              }}
            />
          </div>,
          document.body,
        )}
    </>
  );
}
